export default "__VITE_ASSET__gDbnHwj0__"